"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var _default = nodejsCustomInspectSymbol;
exports.default = _default;



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/nodejsCustomInspectSymbol.js
// module id = 88
// module chunks = 18